<template>
    <div class="map_area service-page">
        <div class="map_column d-flex" v-animate="'fade-in'" v-for="post in posts" :key="post.id" :id="post.idem">
            <div class="map_column_part">
                <h3 class="map_title" v-html="post.title"></h3>
                <p class="map_text" v-html="post.text"></p>
                <p class="map_address" v-html="post.address"></p>
                <div v-if="post.url" class="fw-bold"><a :href="post.url" target="_blank" class="map_anchor">Official Website</a></div>
            </div>
            <div class="map_column_part hover-anim">
                <div class="map_image img-area">
                    <iframe :src="post.src" style="border:0;" allowfullscreen="" loading="lazy" class="map_iframe"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SingaporeMaps',
    data() {
        return {
            posts: [
                {
                    idem: 'map1',
                    title: 'oRo Digital Asia Pte. Ltd.',
                    text: 'Director: Masaru Sanka<br />開業: 2010年1月19日<br />資本金: 70,000米ドル',
                    address: 'Level 4, 21 Merchant Road, 04-01, Singapore 058267',
                    src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.810613140979!2d103.84272981475398!3d1.2877672990607503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190aca7ee5f1%3A0xe353cdb2e291a856!2s21%20Merchant%20Rd%2C%20Level%204%2C%20Singapore%20058267!5e0!3m2!1sen!2sjp!4v1641364127708!5m2!1sen!2sjp'
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .image {
        width: 100%;
        height: auto;
    }

    .img-area {
            img {
                margin-right: 1rem;
                height: auto;
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                filter: grayscale(100%);
                transition: all .5s ease;
                object-fit: contain;
                object-position: left;

                &:last-child {
                    margin-right: 0;
                }
            }
        }

    .map_area {
        padding: 0 0 100px 0;
        border-bottom: 1px solid #eeeeee;
    }

    .map_column {
        justify-content: space-between;

        &:not(:first-child) {
            margin-top: 96px;
        }

        &:first-child {
            padding-top: 110px;
        }

        &:nth-child(2) {
            padding-top: 96px;
            margin-top: 0;
        }

        &:last-child {
            border-top: 2px solid #eeeeee;
            padding-top: 109px;
        }
    }

    .map_column_part:first-child {
        width: 58.3%;
        padding-left: 6.8%;
    }

    .map_column_part:last-child {
        width: 41.7%;
    }

    .map_title {
        font-size: 28px;
        margin-bottom: 37px;
    }

    .map_text {
        font-size: 28px;
        font-weight: 500;
        line-height: 1.4;
        margin-bottom: 36px;
    }

    .map_address {
        line-height: 1.8;
        margin-bottom: 0;
    }

    .map_anchor {
        padding-left: 38px;
        display: inline-block;
        position: relative;
        transition: all 0.3s;
        margin-top: 8px;

        &::before {
            content: '';
            display: block;
            width: 25px;
            height: 20px;
            background: url('../../assets/icons/external_2.svg') no-repeat left center;
            background-size: cover;
            position: absolute;
            left: 0;
            top: calc(50% - 10px);
            transition: all 0.3s;
        }

        &:hover {
            color: #000000;
            text-decoration: underline;
        }

        &:hover::before {
            background: url('../../assets/icons/external_2_hover.svg') no-repeat left center;
            background-size: cover;
        }
    }

    .map_image {
        overflow: hidden;
        
        .image {
            transition: all 0.3s;
        }
    }

    .map_image:hover .image {
        transform: scale(1.2);
    }

    .map_iframe {
        width: 100%;
        height: 320px;
    }

    @media screen and (max-width: 767px) {
        .img-area {
            img {
                width: 100% !important;
                margin-right: 0;
                -webkit-filter: none;
                -moz-filter: none;
                filter: none;
                &.sp-mb-1 {
                    margin-bottom: 1rem;
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        .map_column {
            display: block !important;
            padding-left: 10%;
        }

        .map_column_part:first-child {
            width: 100%;
            margin-bottom: 60px;
            padding-left: 0;
        }

        .map_column_part:last-child {
            width: 100%;
        }

        .map_area {
            padding-top: 100px;
        }

        .map_image:hover .image {
            transform: inherit;
        }
    }
</style>
